import axios from '../lib/axios';

export const getCampaigns = () => axios.get('/api/campaigns');
export const getCampaign = (id) => axios.get(`/api/campaigns/${id}`);
export const createCampaign = (data) => axios.post('/api/campaigns', data);
export const updateCampaign = (id, data) => axios.put(`/api/campaigns/${id}`, data);
export const deleteCampaign = (id) => axios.delete(`/api/campaigns/${id}`);

export const launchCampaign = (id) => axios.post(`/api/campaigns/${id}/launch`);
export const pauseCampaign = (id) => axios.post(`/api/campaigns/${id}/pause`);
export const resumeCampaign = (id) => axios.post(`/api/campaigns/${id}/resume`);
export const cancelCampaign = (id) => axios.post(`/api/campaigns/${id}/cancel`);

export const getCampaignRecipients = (id, params) => axios.get(`/api/campaigns/${id}/recipients`, { params });
export const getCampaignOptions = () => axios.get('/api/campaigns/options');
export const previewAudience = (filtros) => axios.post('/api/campaigns/audience-preview', { filtros });
export const previewMessages = (data) => axios.post('/api/campaigns/message-preview', data);

export const getLineProtection = () => axios.get('/api/campaigns/protection');
export const updateLineProtection = (data) => axios.put('/api/campaigns/protection', data);
